module.exports = __webpack_public_path__ + "static/media/crop_rings.1a26a5e8.svg";